










import { defineComponent, computed } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import uploadDocument from '@/gql/uploadDocument.gql';

const CommonDropzoneWithDocumentUpload = defineComponent({
  setup(props, context) {
    const variables = computed(() => ({
      type: props.type,
    }));

    const mutation = useMutation(uploadDocument);

    mutation.onDone((result) => {
      context.emit('done', result?.data.uploadDocument);
    });

    return {
      variables,
      mutation,
    };
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (val: string) => ['BOOK', 'MAGAZINE'].indexOf(val) !== -1,
    },
  },
});

export default CommonDropzoneWithDocumentUpload;
